// extracted by mini-css-extract-plugin
export default {"Sidebar":"PnOBZAn1","logo":"Mep_tlvF","logoLink":"ooZX0SeI"};
    if(module.hot) {
      // 1764331282733
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  